export const readFileAsBase64 = (file: File) =>
    new Promise<string>((resolve, reject) => {
        const reader = new FileReader()
        reader.onerror = () => reject(reader.error ?? new Error('Fehler beim Lesen der Datei.'))
        reader.onload = () => {
            const result = reader.result
            if (typeof result !== 'string') {
                reject(new Error('Ungültiges Dateiformat.'))
                return
            }
            const base64Data = result.split(',')[1]
            if (!base64Data) {
                reject(new Error('Konnte Datei nicht umwandeln.'))
                return
            }
            resolve(base64Data)
        }
        reader.readAsDataURL(file)
    })
